import React, { useState } from "react";
import { SbEditableBlok, sbEditable } from "@storyblok/storyblok-editable";
import {
  ManageBookingRetrieveWidgetV2,
  ManageBookingRetrieveWidgetV2Props
} from "components/V2/organisms/ManageBookings/ManageBookingRetrieveWidgetV2/ManageBookingRetrieveWidgetV2";
import { extractResource } from "helper/extractResource";
import { ButtonV2 } from "../../../atoms/ButtonV2/ButtonV2";
import { HeadingV2 } from "../../../atoms/HeadingV2/HeadingV2";
import { ImageV2, ImageV2Props } from "../../../atoms/ImageV2/ImageV2";
import { RichTextV2, RichTextV2Props } from "../../../atoms/RichTextV2/RichTextV2";
import { feedBackButtonVisibility } from "@/utils/sidebarButton";

interface MyBookingButtonV2Props {
  blok: {
    image: ImageV2Props["blok"][];
    text: RichTextV2Props["blok"][];
    retrieveBookingPopupData: ManageBookingRetrieveWidgetV2Props["blok"][];
  };
  resourceData: {};
  className: string;
  key: string;
}

export function MyBookingButtonV2({
  blok: { image: imageBlokArray, text: textBlokArray, retrieveBookingPopupData, ...blokData },
  className,
  key,
  resourceData
}: MyBookingButtonV2Props) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [image] = imageBlokArray || [];
  const [text] = textBlokArray || [];
  const [retrieveBookingPopup] = retrieveBookingPopupData || [];

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
    feedBackButtonVisibility(isPopupOpen);
  };

  return (
    <div className={`relative px-1 pr-4 pb-5 top-1 w-full ${className}`} {...sbEditable(blokData as SbEditableBlok)} key={key}>
      <ButtonV2
        additionalButtonClassName="flex items-center justify-center flex-col w-full bg-white card-shadow px-[16px] py-[15px] dark:bg-gray-900"
        onClick={togglePopup}
        fullWidth
      >
        <ImageV2 blok={image} />
        <RichTextV2
          additionalClasses="whitespace-nowrap text-sm font-semibold text-charcoal dark:text-primary"
          blok={text}
        />
      </ButtonV2>

      {isPopupOpen && (
        <div className="fixed top-[88px] left-0 w-screen h-screen bg-white dark:bg-black z-50 flex flex-col md:hidden">
          <div className="flex items-center justify-between p-6">
            <HeadingV2
              blok={{
                displayText: extractResource(resourceData, "myBookings"),
                tagType: "h2",
                viewType: "h5",
                isBold: true,
                isItalic: false,
                color: ""
              }}
            />
            <ButtonV2
              blok={{
                variant: "icon",
                leadingIcon: [{ alt: "Close icon", height: 16, width: 16, icon: "cross-gray" }]
              }}
              onClick={togglePopup}
            />
          </div>
          <ManageBookingRetrieveWidgetV2 module="booking" blok={retrieveBookingPopup} resourceData={resourceData} />
        </div>
      )}
    </div>
  );
}

export default MyBookingButtonV2;
